import {
  readDeviceLanguage,
  setUiLanguage,
  storeDeviceLanguage,
} from "$/lib/language-preference"
import translationQueries from "$/lib/queries/translation-queries"
import { userQueryOptions } from "$/lib/queries/user-queries"
import { DateUtils, STOCKHOLM_TIME_ZONE } from "@repo/common"
import "@repo/ui/lib/i18n-config"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"
import React from "react"
import { IntlProvider } from "use-intl"

/**
 * Renders the app in the logged-in user's language, or the device's last
 * used language before anyone is logged in.
 */
export const TranslationProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  // Reads whatever the auth flow already cached; never fetches on its own
  const { data: user } = useQuery({ ...userQueryOptions, enabled: false })
  const language = user?.language ?? readDeviceLanguage()
  const { data: dictionary } = useSuspenseQuery(
    translationQueries.dictionary(language),
  )

  React.useEffect(() => {
    if (user) storeDeviceLanguage(user.language)
  }, [user])

  // DateUtils formats outside React, and the API client sends the language
  // for part names, so both follow it here before the children render
  DateUtils.setLanguage(language)
  setUiLanguage(language)

  return (
    <IntlProvider
      locale={language}
      messages={dictionary.messages}
      timeZone={STOCKHOLM_TIME_ZONE}
    >
      {children}
    </IntlProvider>
  )
}
